<!-- 视频播放 -->
<template>
    <div>
        <div class="content">
            <div class="bigBox">
                <div class="volBox">
                    <vue-aliplayer-v2
                        :encryptType="1"
                        v-if="showVideo"
                        :vid="vid"
                        :source="source" 
                        ref="player"
                        :isLive="false"
                        :cover="cover"
                        :options="options"
                        @ready="readyPlay" 
                        @play="startPlay"
                        @pause="pausePlay"
                        @error="error"
                        @ended="inserVideEndRecord"
                        @snapshoted="snapshoted"
                    />
                    <div class="bannerVideoBox" @click="bannerVideoPlay()" v-if="baneerShow">
                        <video id="bannerVideo" class="video" :controls="false" playsinline :src="bannerVideo" v-if="bannerVideo"></video>
                        <div class="closeBannerBtn" v-show="bannerTime > 0" @click="closeBanner()">
                            {{ bannerTime }}秒会员关闭广告
                        </div>
                        <img class="bannerPlayBtn" v-show="playBtnShow" src="../../assets/images/play.png" alt="">
                    </div>

                    <div class="noVipBox" v-if="playType <= 0 && !showVideo">
                        <img class="coverBgi" src="../../assets/images/livebg.png" alt="">
                        <div class="toastBox">
                            <div class="titles">{{ videoInfo.name }}</div>
                            <div class="typeBox">
                                <span v-show="saleVipPrice < 0.01" >会员免费</span>
                                <span v-show="saleVipPrice >= 0.01">会员价:{{ saleVipPrice }}</span>
                            </div>
                            <div class="btnBox">
                                <el-button size="small" type="primary" @click="reload()">刷新</el-button>
                                <el-button v-show="saleVipPrice < 0.01" size="small" type="primary" @click="jumpMember()">购买会员</el-button>
                                <el-button v-show="saleVipPrice >= 0.01" size="small" type="primary" @click="goAppToast()">购买课程</el-button>
                            </div>
                        </div>
                    </div>

                    <transition name="el-fade-in-linear">
                        <div v-show="addShow" class="transitionBox">
                            <img class="voiceIcon" src="../../assets/images/voiceIcon.png" alt="">{{ volumeNum }}%
                        </div>
                    </transition>
                    
                    <div class="videoTitle" @click="testfun">
                        <div class="text">
                            {{ videoInfo.name }}
                        </div>
                        <div class="text teachers" v-show="teachersName">
                            讲师:{{ teachersName }}
                        </div>
                    </div>
                </div>

                <div class="videoList">
                    <div class="tabList">
                        <div :class="activeTab == 0?'tabItem activeTab':'tabItem'" @click="activeTab = 0">选集</div>
                        <div :class="activeTab == 1?'tabItem activeTab':'tabItem'" @click="activeTab = 1">AI看课</div>
                        <!-- <div :class="activeTab == 4?'tabItem activeTab':'tabItem'" v-show="pptList.length > 0" @click="activeTab = 4">AI总结</div>
                        <div :class="activeTab == 5?'tabItem activeTab':'tabItem'" @click="activeTab = 5">AI助教</div> -->
                        <div :class="activeTab == 3?'tabItem activeTab':'tabItem'" @click="activeTab = 3">笔记</div>
                        <div :class="activeTab == 2?'tabItem activeTab':'tabItem'" @click="activeTab = 2">讨论</div>
                    </div>
                    <div class="tabContentBox" v-show="activeTab == 0">
                        <div class="videoItemList">
                            <div :class="item.videoNo == videoInfo.No?'videoItem activeVideoItem':'videoItem'" @click="jumpVideoItem(item)" v-for="(item, index) in course_list" :key="index">
                                <div class="videoTitle">
                                    {{ item.videoName }}
                                </div>
                                <div class="videoInfo">
                                    <img class="videoIcon" :src="item.videoNo == videoInfo.No? require('../../assets/images/videoDetailIcon2.png'):require('../../assets/images/videoDetailIcon1.png')" alt="">
                                    <span>
                                        时长：{{ item.videoTime }} 
                                    </span>
                                    <span v-show="item.teachers" class="teachers">
                                        讲师：{{ item.teachers }}
                                    </span>
                                    <div class="downloadFileBtn" v-show="item.fileUrl" @click.stop="downloadFile(item)">
                                        <img  class="downloadFileIcon" src="../../assets/images/downloadFileIcon.png" alt="">
                                        下载课件
                                    </div>
                                </div>
                                <img v-show="item.salePrice == 0" class="labelIcon" src="../../assets/images/videoDetailIcon3.png" alt="">
                                <img v-show="item.salePrice > 0" class="labelIcon" src="../../assets/images/videoDetailIcon4.png" alt="">
                            </div>
                        </div>
                    </div>

                    <div class="tabContentBox" v-show="activeTab == 1">
                        <div class="AItitle">视频摘要</div>
                        <div :class="!AbstractActive?'openVideoAbstract':'videoAbstract'">
                            {{ outline }}
                        </div>
                        <div class="videoAbstractOpenBtn"  @click="AbstractActive = !AbstractActive">
                            <img class="btmIcon" :style="AbstractActive?'':'transform: rotate(180deg);'" src="../../assets/images/videoDetailBtmIcon.png" alt="">
                            <span v-show="AbstractActive">展开</span>
                            <span v-show="!AbstractActive">收起</span>
                        </div>

                        <div class="SummaryBySectionsBox" v-show="chapterList.length > 0">
                            <div class="AItitle">
                                分段总结
                                <div class="videoAbstractOpenBtn"  @click="SummaryActive = !SummaryActive">
                                    <span v-show="SummaryActive">查看全部</span>
                                    <span v-show="!SummaryActive">收起</span>
                                </div>
                            </div>
                            <div :class="!SummaryActive?'SummaryBySectionsList2':'SummaryBySectionsList'">
                                <div class="SummaryBySectionsItem" v-show="item.title" v-for="(item, index) in chapterList" :key="index">
                                    <div class="SummaryBySectionsItemTitle">
                                        <img class="videoIcon" src="../../assets/images/juniorCollegeIcon1.png" alt="" @click="jumpVideoLenght(item)">
                                        {{ item.title }}
                                        <div class="videoTimes">
                                            {{ item.videoTimes }}
                                        </div>
                                    </div>
                                    <div class="SummaryBySectionsContent">
                                        {{ item.summary }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="AItitle">AI问答</div>
                        <div class="qaListBox">
                            <div class="qaItem" v-for="(item, index) in qaList" :key="index">
                                <div class="qBox">
                                    <img class="videoIcon" src="../../assets/images/videoDetailIconQ.png" alt="">
                                    {{ item.question }}
                                </div>
                                <div class="aBox">
                                    <img class="videoIcon" src="../../assets/images/videoDetailIconA.png" alt="">
                                    {{ item.answer }}
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="tabContentBox askContentBox" v-show="activeTab == 2">
                        <div class="askInputBox">
                            <input class="askInput" v-model="askContent" type="text" :placeholder="askPlaceholder">
                            <div class="sendBtn" @click="insertReply()">
                                发送
                            </div>
                        </div>
                        <div class="askItemList" v-if="AskDataList.length > 0">
                            <div class="askItem" v-for="(item, index) in AskDataList" :key="index">
                                <img class="userHeadPortrait" :src="imgSrc + item.userHeadPortrait" alt="">
                                <div class="contentBox">
                                    <div class="userName">
                                        {{ item.userName }}
                                        <span class="deleteBtn" v-show="userNo == item.doctorNo" @click="deleteReply(item)" >删除</span>
                                    </div>
                                    <div class="userContent">
                                        {{ item.content }}
                                    </div>
                                    <div class="contentInfo">
                                        {{ item.askTime }}
                                        <span @click="replyBtn(item)">回复</span>
                                    </div>
                                    <div class="userAskList">
                                        <div class="userAskItem" v-for="(item1, index1) in item.classList" :key="index1">
                                            <span class="doctorName">
                                                {{ item1.userName }}:
                                            </span>
                                            <span class="askContent">
                                                {{ item1.content }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="noAsk" v-else style="font-size:16px;color: #363636;text-align: center;padding-top: 20px;">
                            暂无评论
                        </div>
                    </div>

                    <div class="tabContentBox" v-show="activeTab == 3">
                        <div class="btnList">
                            <div class="allNoteBtn" @click="claerNoteInfo(1)">全部笔记</div>
                            <div class="rightBtn">
                                <div class="btnItem" v-show="false">
                                    预览笔记
                                </div>
                                <div class="btnItem saveBtn" @click="inserNote()">
                                    <img class="videoIcon" src="../../assets/images/videoDetailIcon5.png" alt="">
                                    保存笔记
                                </div>
                            </div>
                        </div>
                        <div class="noteTitleInputBox">
                            <input class="noteTitleInput" v-model="noteTitle" type="text" placeholder="请输入笔记主题，给您的笔记归类">
                        </div>
                        <el-input
                            class="noteContentTextarea"
                            type="textarea"
                            :rows = "7"
                            placeholder="直接输入笔记正文"
                            v-model="noteContent"
                            maxlength="500"
                            show-word-limit
                        >
                        </el-input>
                        <div class="upimgList">
                            <div class="upImgItem" v-for="(item, index) in previewFiles" :key="index">
                                <el-image
                                    class="upImgItemSrc"
                                    :src="item.fileUrl"
                                    @click="deleteNoteImg(item,index)"
                                    fit="contain"
                                    ></el-image>
                                <!-- <img class="upImgItemSrc" :src="item.fileUrl" alt=""> -->
                            </div>
                            <div class="upImgBtn upImgItem" @click="upNoteImg()">
                                上传图片
                            </div>
                        </div>
                    </div>
                    
                    <div class="tabContentBox" v-show="activeTab == 4">
                        <div :class="'PPTDataListBox'">
                            <div class="PPTDataListItem" v-for="(item, index) in pptList" :key="index">
                                <div class="iconBox">
                                    <img class="videoIcon" src="../../assets/images/juniorCollegeIcon1.png" alt="" @click="jumpVideoLenght(item, 'ai5')">
                                    <div class="videoTimes">
                                        {{ item.videoTimes }}
                                    </div>
                                </div>
                                <div class="pptContent">
                                    {{ item.spoken_language }}
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    
                    <div class="tabContentBox askContentBox" style="padding-bottom: 60px;" v-show="activeTab == 5">
                        <div class="textBox" id="chatContainer" v-if="AIoutline.length > 0">
                            <div class="learningTarget">
                                <div class="learningTargetTitle">
                                    学习目标
                                </div>
                                <div class="learningTargetList">
                                    {{ AIoutline }}
                                </div>
                            </div>
                            <div class="answerItem" v-for="(item, index) in textDataBox" :key="index">
                                <div class="rightText">
                                    <!-- {{ item.question }} -->
                                    <div class="aiText" v-html="item.question"></div>
                                </div>
                                <div class="clear" style="clear:right"></div>
                                <!-- 有答案或者正在思考 -->
                                <div class="leftBox" v-if="item.replyText || item.textOver == 1">
                                    <div class="leftImg">
                                        <img class="logo" src="../../assets/images/webAiTitleIcon.png" alt="">
                                        小智
                                    </div>
                                    <div class="leftText" style="padding-left:20px; display: flex;" v-if="item.textOver == 1">
                                        {{ task }}
                                        <div class="loading-container">
                                            <div class="dot dot-1"></div>
                                            <div class="dot dot-2"></div>
                                            <div class="dot dot-3"></div>
                                        </div>
                                    </div>
                                    <div class="leftText" v-if="item.replyText">
                                        <div class="aiText" v-html="item.replyText"></div>
                                        <div class="btnList" v-show="item.textOver == 2">
                                            <div class="btnItem" @click="copyData(item)"><i class="el-icon-copy-document"></i> 复制</div>
                                            <!-- <div class="btnItem" @click="answersLikeOrTap(item, 1, index)">
                                                <img class="icon" :src="item.action == 1?require('../../assets/images/likeIcon1.png'):require('../../assets/images/likeIcon.png')" alt="">赞
                                            </div>
                                            <div class="btnItem" @click="answersLikeOrTap(item, 2, index)">
                                                <img class="icon bottom" :src="item.action == 2?require('../../assets/images/likeIcon1.png'):require('../../assets/images/likeIcon.png')" alt="">踩
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="clear" style="clear:left"></div>
                            </div>
                        </div>
                        <div class="askInputBox">
                            <input class="askInput" v-model="textMsg" type="text" :placeholder="textMsgPlaceholder">
                            <div class="sendBtn" @click="submitQuestion()">
                                发送
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>


            <!-- <div class="videoDetail">
                <div class="videoDetailContent" v-html="videoDetailContent"></div>
            </div> -->
            
        <input id="otherElement" style="display: none;" type="file" @change="upFileData" />

        <el-dialog :visible.sync="dialogVisible" 
            width="800px" 
            :close-on-click-modal="true"
            :title="videoInfo.name"
            :destroy-on-close="true"
            >
            <div class="noteList">
                <div class="noteItem" v-for="(item, index) in allNoteData" :key="index">
                    <div class="noteEditTitle">{{ item.note_title }}</div>
                    <div class="noteTime">
                        <img class="noteIcon" src="../../assets/images/videoDetailIcon1.png" alt="">
                        <div class="tims">0:12:43</div>
                    </div>
                    <div class="noteEditContent">
                        <el-image
                            class="noteImgItemSrc"
                            v-show="item.note_image"
                            :src="imgSrc + item.note_image"
                            fit="contain"></el-image>
                        <div class="contetnText">{{ item.note_content }}</div>
                    </div>
                    <div class="operatingButtonList">
                        <div class="operatingBtnItem" @click="editNote(item)">
                            <img class="noteIcon" src="../../assets/images/videoDetailEditBtn.png" alt="">
                            编辑
                        </div>
                        <div class="operatingBtnItem deleteBtn" @click="deleteNote(item)">
                            <img class="noteIcon" src="../../assets/images/videoDetailDeleteBtn.png" alt="">
                            删除
                        </div>
                    </div>
                </div>
            </div>
		</el-dialog>
        </div>
    </div>
  </template>
  <script>
    import VueAliplayer from "../../components/AliPlayer";
    import VueAliplayerV2 from 'vue-aliplayer-v2';
    import { marked } from 'marked';
    export default {
        components:{ VueAliplayerV2: VueAliplayerV2.Player,"ali-player": VueAliplayer },
        data() {
        return {
			imgSrc: "https://case.chongyike.com",
            // 讲师名称
            teachersName: "",
            // 用户NO
            userNo: "",
            cover: '', //视频封面
            vid: '', //视频vid
            playAuth: '', //鉴权地址
            videoInfo: {},
            source: "",
            // 视频详情
            videoDetail: {},
            // 第一次调用视频详情地址
            playOff: true,
            // 视频详情内容
            videoDetailContent: "",
            // 观看时长秒数
            timeNum: 0,
            // 播放状态ture为播放中，false为暂停
            playingStatus: false,
            // 展示播放器
            showVideo: false,
            // 广告视频地址
            bannerVideo: "",
            // 显示隐藏广告
            baneerShow: false,
            // 广告时长
            bannerTime: "",
            // 是否是会员
            isVip: false,
            // 播放按钮显示
            playBtnShow: false,
            // 开始播放时间
            startTime: "",
            // 观看状态
            playType: 0,
            // 课程价格
            saleVipPrice: 0,
            // 当前音量
            volumeNum: 100,
            // 防抖函数
            volumeFun: {},
            // 音量框显示
            addShow: false,
            // 配置参数
            options: {
                width: "740px",
                height: 740/(16/9)+"px",
                autoplay: false,
                isLive: false,
                // 配置按钮
                skinLayout: [{
                        "name": "bigPlayButton",
                        "align": "cc"
                    },
                    {
                        "name": "H5Loading",
                        "align": "cc"
                    },
                    {
                        "name": "errorDisplay",
                        "align": "tlabs",
                        "x": 0,
                        "y": 0
                    },
                    {
                        "name": "infoDisplay"
                    },
                    {
                        "name": "tooltip",
                        "align": "blabs",
                        "x": 0,
                        "y": 56
                    },
                    {
                        "name": "thumbnail"
                    },
                    {
                        "name": "controlBar",
                        "align": "blabs",
                        "x": 0,
                        "y": 0,
                        "children": [{
                            "name": "progress",
                            "align": "blabs",
                            "x": 0,
                            "y": 44
                        },
                        {
                            "name": "playButton",
                            "align": "tl",
                            "x": 15,
                            "y": 12
                        },
                        {
                            "name": "timeDisplay",
                            "align": "tl",
                            "x": 10,
                            "y": 7
                        },
                        {
                            "name": "fullScreenButton",
                            "align": "tr",
                            "x": 10,
                            "y": 12
                        },
                        {
                            "name": "setting",
                            "align": "tr",
                            "x": 15,
                            "y": 12
                        },
                        {
                            "name": "volume",
                            "align": "tr",
                            "x": 5,
                            "y": 10
                        },
                        {
                            "name": "snapshot",
                            "align": "tr",
                            "x": 10,
                            "y": 12
                        }
                    ]
                }
            ]
            },
            // 右侧切换栏参数
            activeTab: 0, // 当前选中Tab
            // 选集
            course_list: [],
            // AI看课参数
            outline: "", 
            chapterList: [], 
            qaList: [],
            AbstractActive: true, 
            SummaryActive: true,
            // 讨论列表
            AskDataList: [],
            // 发布讨论参数
            askContent: "",
            beUserNo: "",
            beAskid: "",
            // 讨论占位符
            askPlaceholder: "我来说一句",
            // 笔记弹出层
            dialogVisible: false,
            // 上传笔记参数
            noteTitle: "",
            noteContent: "",
            noteVideoTime: 10,
            // 笔记图片
            noteImgList:[],
            previewFiles: [],
            // 线上图片
            onLinePreviewFiles: [],
            // 所有笔记
            allNoteData: [],
            // 编辑笔记ID
            noteId: "",
            // 播放时长记录时长定时器
            PRT: {},
            // ai总结PPT
            pptList: [],
            // ai助教参数
            // 流式数据id
            conversationId: "",
            // 对话数据列表
            textDataBox: [],
            // 是否在回答中
            Answering: false,
            // 问题
            textMsg: "",
            // 问题占位符
            textMsgPlaceholder: "智学提问",
            // 当前思考状态
            task: "思考中",
            // 保存当前问答的ID
            atPresentConversationID: "",
            // 字符串长度
            markedTextlength: 0,
            // 是否可以提问
            QuestionPermission: false,
            // AI学习目标
            AIoutline: "",
        }
      },
        watch: {
            // 回答时滚动条保持在底部
            markedTextlength() {
                this.$nextTick(() => {
                    var container = this.$el.querySelector("#chatContainer");
                    container.scrollTop = container.scrollHeight;
                })
            },
            // 正在回答中的问题在切换之后自动停止
            startAnswer(newVal){
                if(newVal == false && this.Answering){
                    this.stopAnswerts()
                }
            },
            $route(to, from){
                const that = this
                clearInterval(that.PRT)
                that.loadWeb()
            }
        },
        created() {
            const that = this
            that.loadWeb()
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.showLeaveConfirmation);
        },
        beforeRouteLeave(to, from, next) {
            this.inserVipVideTime2()
            next()
        },
        methods: {
            testfun(){
                const that = this
                console.log("点了")
            },
            // 启动页面时的方法
            loadWeb(){
                const that = this
                that.videoInfo = JSON.parse(that.decrypt(this.$route.query.text))
                console.log(that.videoInfo)
                that.getUserVipTime()
                that.getVideoDetailInfo()
                that.getViewSeriesInfo()
                that.getVideoAiInfo()
                // 获取学习目标
                // that.getHotQuestionAndSummary()
                // that.getAskList()
                // that.getVideoAiInfo3()
                // // 获取ai对话历史记录
                // that.getConversationHistory()
                // // 判断是否有提问权限
                // that.iscanQuestion()
                window.addEventListener('pagehide', async function (event) {
                    that.inserVipVideTime2()
                });
            },
            // 键盘按下事件
            keydownClick(e){
                const that = this 
                var keyCode = e.keyCode
                if(keyCode == "32"){
                    // 禁用默认按键方法
                    e.preventDefault()
                    // 空格切换暂停播放
                    if(that.playingStatus){
                        that.$refs.player.pause()
                    }else {
                        that.$refs.player.play()
                    }
                }else if(keyCode == "37"){
                    // 左箭头
                    var positionTime = Math.floor(that.$refs.player.getCurrentTime())
                    that.$refs.player.seek(positionTime - 10)
                }else if(keyCode == "39"){
                    // 右箭头
                    var positionTime = Math.floor(that.$refs.player.getCurrentTime())
                    that.$refs.player.seek(positionTime + 10)
                }else if(keyCode == "38"){
                    // 上箭头
                    e.preventDefault()
                    that.addShow = true
                    var vol = that.$refs.player.getVolume()*100
                    var timeNum = 0
                    if(vol < 100){
                        // 超过一百设置为一百
                        if(vol + 5 > 100){
                            that.$refs.player.setVolume(1)
                        }else{
                            timeNum = 5
                            that.$refs.player.setVolume(Math.floor(vol+timeNum)/100)
                        }
                    }
                    that.volumeNum = Math.floor(vol+timeNum)
                    if(that.volumeFun){
                        clearTimeout(that.volumeFun);
                    }
                    that.volumeFun = setTimeout(() => {
                        that.addShow = false
                    }, 1000);
                }else if(keyCode == "40"){
                    // 下箭头
                    e.preventDefault()
                    that.addShow = true
                    var vol = that.$refs.player.getVolume()*100
                    var timeNum = 0
                    if(vol > 5){
                        timeNum = 5
                        that.$refs.player.setVolume(Math.floor(vol-timeNum)/100)
                    }
                    that.volumeNum = Math.floor(vol-timeNum)
                    if(that.volumeFun){
                        clearTimeout(that.volumeFun);
                    }
                    that.volumeFun = setTimeout(() => {
                        that.addShow = false
                    }, 2000);
                }
            },
            // 提示购买
            goAppToast(){
                this.$message({
                    showClose: true,
                    message: "请前往宠医客APP进行购买",
                    type: 'success',
                    duration: 2000
                });
            },
            // 跳转视频对应位置
            jumpVideoLenght(item, type){
                if(type == 'ai5'){
                    this.$refs.player.seek(item.start_position/1000)
                }else {
                    this.$refs.player.seek(item.start/1000)
                }
            },
            // 跳转购买会员
            jumpMember(){
                this.$router.push({
                    path: '/member',
                })
            },
            // 跳转对应课程
            jumpVideoItem(item){
                const that = this
                var data = {
                    dataType: that.videoInfo.dataType,
                    No: item.videoNo,
                    name: item.videoName,
                    classType: that.videoInfo.classType,
                    classId: that.videoInfo.classId
                }
                that.$router.push({
                    path: '/videoDetail',
                    query: {
                        text: that.encrypt(JSON.stringify(data))
                    }
                })
            },
            // 刷新
            reload(){
                window.location.reload()
            },
            startSeek(e){
                const that = this
            },
            showLeaveConfirmation(event) {
                this.inserVipVideTime2()
                const message = '您确定要离开此网站吗？';
                event.returnValue = message; // 兼容性设置
                return message;
            },
            // 请求视频地址
            getVideoPlayParameters(){
                const that = this
                var data = {
                    type: 'getVideoPlayParameters',
                    dataType: that.videoInfo.dataType,
                    dataNo: that.videoInfo.No,
                    classType: that.videoInfo.classType,
                    classId: that.videoInfo.classId
                }
                this.get("/4/handler", data).then((res) => {
                    if (res.data.code == "success") {
                        that.getVideoAd()
                        var result = JSON.parse(this.decrypt(res.data.result))
                        var mdNo = that.hex_md5(that.videoInfo.No).substring(3, 19)
                        var oneData = JSON.parse(that.decrypt(result.playInfoStr, mdNo))
                        var mdTowNo = that.hex_md5(that.videoInfo.No).substring(2, 18);
                        var sourceBox = that.decrypt(oneData.source, mdTowNo);
                        var data = {
                            SD: JSON.parse(sourceBox).SD
                        }
                        that.playType = result.playType
                        if(result.playType > 0){
                            that.showVideo = true
                            that.cover = that.imgSrc + result.videoImage
                            that.source = JSON.stringify(data)
                            that.vid = oneData.aliVid
                            setTimeout(() => {
                                if(result.historyPosition){
                                    that.$refs.player.seek(result.historyPosition)
                                }
                            }, 1500);
                            that.playRecordTimer(result.historyPosition)
                        }else {
                            var saleVipPrice = result.saleVipPrice
                            that.saleVipPrice = saleVipPrice
                        }
                    }
                })
            },
            // 获取视频详情
            getVideoDetailInfo(){
                const that = this
                var data = {
                    type: 'getVideoDetailInfo',
                    videoNo: that.videoInfo.No,
                }
                this.get("/webhttp/mobileHandler", data).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        document.title = result.video.videoName + '-宠医客'
                        that.videoDetail = result.video
                        that.teachersName = result.video.teachers
                        that.getVideoPlayParameters()
                        that.getDataInfo()
                    }
                })
            },
            playRecordTimer(historyPosition){
                const that = this
                that.playRecord(historyPosition)
                that.PRT = setInterval(()=>{
                    that.playRecord()
                }, 20000)
            },
            // 播放记录上传
            playRecord(historyPosition){
                const that = this
                var playPosition = 0
                if(historyPosition){
                    playPosition = historyPosition
                }
                if(!that.playOff){
                    try {
                        playPosition = Math.floor(that.$refs.player.getCurrentTime())
                    } catch (error) {
                    }
                }
                var data = {
                    type: 'playRecord',
                    videoNo: that.videoInfo.No,
                    playPosition: playPosition
                }
                this.get("/3/handler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.playOff = false
                    }
                })
            },
            // 视频介绍详情
            getDataInfo(){
                const that = this
                var data = {
                    type: 'getDataInfo',
                    dataNo: that.videoInfo.No,
                    dataType: "15" // 视频15  直播17  执兽83
                }
                this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.videoDetailContent = result.Demandxq.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, (
                            match, p1) => {
                            return `<img style="width:100%;display:block;" src='${'https://case.chongyike.com' + p1}' />`
                        })
                    }
                })
            },
            // 记录播放时长
            inserVipVideTime2(){
                const that = this
                if(that.timeNum < 5){
                    return false
                }
                localStorage.setItem('lookTime', that.timeNum);
                var data = {
                    type: 'videoDurationRecord',
                    videoNo: that.videoInfo.No,
                    startTime: that.startTime,
                    duration: that.timeNum,
                    videoPosition: Math.floor(that.$refs.player.getCurrentTime())
                }
                this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.startTime = new Date().getTime()
                        that.timeNum = 0
                    }
                })
            },
            // 获取选集
            getViewSeriesInfo(){
                const that = this
                var data = {
                    type: 'getViewSeriesInfo',
                    dataNo: that.videoInfo.No,
                    listType: '',
                    listId: '',
                }
                this.get("/3/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        var course_list = result.course_list
                        // 视频时长转换
                        for (let i = 0; i < course_list.length; i++) {
                            course_list[i].videoTime =  that.secondsToTime(course_list[i].videoLength)
                        }
                        that.course_list = course_list
                    }
                })
            },
            // 获取AI看课
            getVideoAiInfo(){
                const that = this
                var data = {
                    type: 'getVideoAiInfo',
                    videoNo: that.videoInfo.No,
                }
                this.get("/4/handler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        for (let i = 0; i < result.chapterList.length; i++) {
                            result.chapterList[i].videoTimes = that.secondsToTime(Math.floor(result.chapterList[i].start/1000))
                        }
                        that.outline = result.outline
                        that.chapterList = result.chapterList
                        that.qaList = result.qaList
                        // Object.keys(result).forEach(function(key) {
                        //     that[key] = result[key]
                        // });
                    }
                })
            },
            // 获取讨论列表
            getAskList(){
                const that = this
                var data = {
                    type: 'getAskList',
                    dataType: "15",
                    dataNo: that.videoInfo.No,
                }
                this.get("/3/handler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        var userInfo = that.Cookies.get('loginInfo')
                        that.userNo = JSON.parse(userInfo).No
                        that.AskDataList = result
                        // 查询笔记 
                        that.selectNote()
                    }
                })
            },
            // 下载课件 
            downloadFile(item) {
                const that = this
                if(that.isVip){
                    const url = that.imgSrc + item.fileUrl; // 替换成你要下载的文件的URL
                    fetch(url).then(_ => _.blob()).then(_ => {
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(_);
                        link.setAttribute('download', that.videoInfo.name);
                        link.click();
                    })
                }else {
                    this.$message({
                        showClose: true,
                        message: "请购买会员后下载课件",
                        duration: 2000
                    });
                }
            },
            // 选择回复评论
            replyBtn(item){
                const that = this
                that.beAskid = item.askId
                that.beUserNo = item.doctorNo
                that.askPlaceholder = "回复@" + item.userName
            },
            // 发送评论
            insertReply(){
                const that = this
                if(that.askContent.trim() == ""){
                    this.$message({
                        showClose: true,
                        message: "请输入讨论内容",
                        duration: 2000
                    });
                    return false
                }
                var data = {
                    type: 'insertReply',
                    dataType: "15",
                    dataNo: that.videoInfo.No,
                    content: that.askContent,
                    beUserNo: that.beUserNo,
                    beAskid: that.beAskid,
                }
                this.get("/3/handler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.askContent = ""
                        that.beAskid = ""
                        that.beUserNo = ""
                        that.askPlaceholder = "参与讨论"
                        that.getAskList()
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'success',
                            duration: 2000
                        });
                    }
                })
            },
            // 删除评论
            deleteReply(item){
                const that = this
                this.$confirm('是否删除评论?', '提示', {
                    confirmButtonText: '确定删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var data = {
                        type: 'deleteReply',
                        dataType: "15",
                        askId: item.askId,
                    }
                    this.get("/3/handler", data, 1).then((res) => {
                        if (res.data.code == "success") {
                            var result = res.data.result
                            that.getAskList()
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'success',
                                duration: 2000
                            });
                        }
                    })
                }).catch(() => {
                             
                });
            },
            // 清空笔记
            claerNoteInfo(type){
                const that = this
                that.noteId = ""
                that.noteTitle =  ""
                that.noteContent =  ""
                that.noteImgList =  []
                that.previewFiles =  []
                if(type == 1){
                    that.dialogVisible = true
                }
            },
            // 上传笔记
            inserNote(){
                const that = this
                if(that.noteId != ''){
                    that.updateNote2()
                }else {
                    if(that.noteTitle == ""){
                        this.$message({
                            showClose: true,
                            message: "请输入笔记主题",
                            duration: 2000
                        });
                        return false
                    }
                    if(that.noteContent == ""){
                        this.$message({
                            showClose: true,
                            message: "请输入笔记内容",
                            duration: 2000
                        });
                        return false
                    }
                    var data = {
                        type: 'inserNote2',
                        videoId: that.videoInfo.No,
                        videoType: "0",
                        noteVideoTime: that.noteVideoTime,
                        userNo: that.userNo
                    }
                    var uploadFile = new FormData();
                    uploadFile.append("noteTitle", that.noteTitle);
                    uploadFile.append("noteContent", that.noteContent);
                    if(that.noteImgList.length > 0){
                        for (var i = 0; i < that.noteImgList.length; i++) {
                            uploadFile.append("NOTE_IMG_PATH", that.noteImgList[i]);
                        }
                    }
                    this.post("/webhttp/mobileHandler", data, uploadFile).then((res) => {
                        if (res.data.code == "success") {
                            var result = res.data.result
                            that.claerNoteInfo()
                            that.selectNote()
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'success',
                                duration: 2000
                            });
                        }
                    })
                }
            },
            // 删除笔记
            deleteNote(item){
                this.$confirm('是否删除笔记?', '提示', {
                    confirmButtonText: '确定删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const that = this
                    var data = {
                        type: 'deleteNote',
                        noteIds: item.id,
                        userNo: that.userNo
                    }
                    this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                        if (res.data.code == "success") {
                            var result = res.data.result
                            that.selectNote()
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'success',
                                duration: 2000
                            });
                        }
                    })
                }).catch(() => {
                             
                });
            },
            // 修改笔记
            updateNote2(){
                const that = this
                var data = {
                    type: 'updateNote2',
                    noteId: that.noteId,
                    noteVideoTime: 10,
                    userNo: that.userNo
                }
                // 处理线上图片
                var noteImages = ""
                for (let i = 0; i < that.onLinePreviewFiles.length; i++) {
                    if(i == 0){
                        noteImages += that.onLinePreviewFiles[i]
                    }else {
                        noteImages += "<->" + that.onLinePreviewFiles[i]
                    }
                }
                data.noteImages = noteImages
                // 处理新增图片
                var uploadFile = new FormData();
                uploadFile.append("noteTitle", that.noteTitle);
                uploadFile.append("noteContent", that.noteContent);
                if(that.noteImgList.length > 0){
                    for (var i = 0; i < that.noteImgList.length; i++) {
                        uploadFile.append("NOTE_IMG_PATH", that.noteImgList[i]);
                    }
                }
                this.post("/webhttp/mobileHandler", data, uploadFile).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.claerNoteInfo()
                        that.selectNote()
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'success',
                            duration: 2000
                        });
                    }
                })
            },
            // 选中编辑笔记
            editNote(item){
                const that = this
                that.noteId = item.id
                that.noteTitle = item.note_title
                that.noteContent = item.note_content
                    for (let i = 0; i <  item.imgArr.length; i++) {
                        that.previewFiles.push({
                            fileUrl: that.imgSrc + item.imgArr[i],
                            imgType: "onLine"
                        })
                    }
                    that.onLinePreviewFiles = item.imgArr
                that.dialogVisible = false
            },
            // 上传笔记图片
            upNoteImg(){
                const otherElement = document.getElementById('otherElement');
                if (otherElement) {
                    otherElement.click();
                }
            },
            // 上传文件
            upFileData(event){
                const that = this
                const selectedFiles = Array.from(event.target.files); // 将FileList转换为数组
                selectedFiles.forEach(file => {
                    // 创建预览URL，仅适用于图片等可以直接通过URL访问的文件类型
                    const previewURL = URL.createObjectURL(file);
                    if(file.size > (1024*1024*10)){
                        that.$message({
                            showClose: true,
                            message: "请选择小于10M的文件",
					        type: 'error'
                        });
                    }else {
                        this.previewFiles.push({ fileUrl: previewURL, files:file});
                        that.noteImgList.push(file);
                    }
                });
            },
            // 删除图片
            deleteNoteImg(item,index){
                const that = this
                if(item.imgType == "onLine"){
                    // 线上图片处理
                    var imgIndex
                    for (let i = 0; i < that.onLinePreviewFiles.length; i++) {
                        if(that.imgSrc + that.onLinePreviewFiles[i] == item.fileUrl){
                            imgIndex = i
                        }
                    }
                    that.onLinePreviewFiles.splice(imgIndex, 1)
                    that.previewFiles.splice(imgIndex, 1)
                }else {
                    // 新增图片处理
                    var imgIndex
                    for (let i = 0; i < that.noteImgList.length; i++) {
                        if(that.noteImgList[i] == item.files){
                            imgIndex = i
                        }
                    }
                    that.noteImgList.splice(imgIndex, 1)
                    that.previewFiles.splice(imgIndex, 1)
                }
            },
            // 查询全部笔记
            selectNote(){
                const that = this
                var data = {
                    type: 'selectNote',
                    // videoId: that.videoInfo.No,
                    userNo: that.userNo
                }
                this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        for (let i = 0; i < result.length; i++) {
                            if(result[i].note_images){
                                result[i].imgArr = result[i].note_images.split("<->")
                            }else {
                                result[i].imgArr = []
                            }
                        }
                        that.allNoteData = result
                    }
                })
            },
            // 计时器
            timer(){
                const that = this
                setTimeout(() => {
                    if(that.playingStatus){
                        that.timeNum+=1
                        that.timer()
                    }
                }, 1000);
            },
            // 准备完成
            readyPlay(){
                const that = this
                window.addEventListener("keydown", this.keydownClick)
            },
            // 开始播放
            startPlay(){
                const that = this
                that.playingStatus = true
                that.startTime = new Date().getTime()
                that.timer()
                window.addEventListener('beforeunload', this.showLeaveConfirmation);
            },
            // 暂停播放
            pausePlay(){
                const that = this
                that.playingStatus = false
                that.inserVipVideTime2()
            },
            // 报错
            error(e){
                const that = this
                console.error(e)
            },
            // 播放完成
            inserVideEndRecord(){
                const that = this
                var data = {
                    type: 'inserVideEndRecord',
                    videoNo: that.videoInfo.No,
                }
                this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                    }
                })
            },
            // 加载广告
            getVideoAd(){
                const that = this
                var data = {
                    type: 'getVideoAd',
                }
                this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        if(result){
                            that.bannerVideo = result.video_url
                            that.baneerShow = true
                            that.playBtnShow = true
                        }
                    }
                })
            },
            // 广告播放开始
            bannerVideoPlay(){
                const that = this
                var video = document.querySelector('#bannerVideo')
                that.playBtnShow = false
                video.play()
                that.bannerTime = Math.ceil(video.duration)
                that.bannerVideoTime()
            },
            // 广告播放倒计时
            bannerVideoTime(){
                const that = this
                if(that.bannerTime <= 0){
                    that.baneerShow = false
                }else {
                    setTimeout(() => {
                        that.bannerTime--
                        that.bannerVideoTime()
                    }, 1000);
                }
            },
            // 会员关闭广告
            closeBanner(){
                const that = this
                if(that.isVip){
                    that.bannerTime = 0
                    that.baneerShow = false
                }else {
                    this.$confirm('是否前往购买会员?', {
                        confirmButtonText: '前往购买',
                        cancelButtonText: '取消',
                    }).then(() => {
                        that.$router.push({
                            path: '/member',
                        })
                    })
                }
            },
            // 获取会员信息
            getUserVipTime(){
                const that = this
                var data = {
                    type: 'getUserVipTime',
                }
                this.get("/webhttp/mobileHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        if(result){
                            that.isVip = true
                        }
                    }
                })
            },
            // 获取ai助教学习目标
            getHotQuestionAndSummary(){
                const that = this
                var data = {
                    type: 'getHotQuestionAndSummary',
                    dataType: 1,
                    dataNo: that.videoInfo.No,
                }
                this.get("/ai/videoAssistantHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        if(result.outline){
                            that.AIoutline = result.outline
                        }
                    }
                })
            },
            snapshoted(data){
                var pictureData = data.paramData.base64
                var base64 = pictureData.toString(); // img 就是base64
                var byteCharacters = atob(
                base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
                );
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], {
                type: undefined,
                });
                var aLink = document.createElement("a");
                aLink.download = data.paramData.time + ".jpg"; //这里写保存时的图片名称
                aLink.href = URL.createObjectURL(blob);
                aLink.click();

            },

            // 新版内容
            getVideoAiInfo3(){
                const that = this
                var data = {
                    type: 'getVideoAiInfo3',
                    videoNo: that.videoInfo.No,
                }
                this.get("/4/handler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = JSON.parse(this.decrypt(res.data.result))
                        for (let i = 0; i < result.pptList.length; i++) {
                            result.pptList[i].videoTimes = that.secondsToTime(Math.floor(result.pptList[i].start_position/1000))
                        }
                        that.pptList = result.pptList
                    }
                })
            },

            // ai助教
            
            // 发送问题
            submitQuestion(){
                const that = this
                if(!that.QuestionPermission){
                    that.$message({
                        message: "请开通会员后提问",
                    });
                    return false
                }
                // 是否正在回答
                if(that.Answering){
                    that.stopAnswerts()
                }else {
                    if(that.textMsg.trim() == ""){
                        that.$message({
                            message: "请输入问题",
                        });
                        return false
                    }
                    // 开始问答
                    that.startAnswer = true
                    that.Answering = true
                    var uploadFile = new FormData();
                    // 数组添加新提问
                    var data = {
                        question: that.textMsg,
                        replyText: "",
                        outputs: [],
                        extendOff: false,
                        relatedreCommended: [],
                        filesArr: that.previewFiles
                    }
                    that.textDataBox.push(data)
                    uploadFile.append("question", that.textMsg);
                    var data = {
                        type: 'submitQuestion',
                        conversationId: that.conversationId,
                        accessType: '2', // 1APP课程播放页，2官网课程播放页
                        dataType: that.videoInfo.dataType,
                        dataNo: that.videoInfo.No,
                        listType: that.videoInfo.classType,
                        listId: that.videoInfo.classId
                    }
                    this.post("/ai/videoAssistantHandler", data, uploadFile).then((res) => {
                        if (res.data.code == "success") {
                            var result = res.data.result
                            document.title = that.textMsg.slice(0,10) + "- 智答"
                            if(sessionStorage.getItem("AiQuestion")){
                                sessionStorage.removeItem("AiQuestion")
                            }
                            that.markedTextlength+=1
                            that.sessionId = result.session_id
                            // 建立流式回复
                            that.connectToServer(result.session_id)
                            that.textDataBox[that.textDataBox.length-1].textOver = 1
                            // 清空输入框
                            that.textMsg = ""
                        }else {
                            that.Answering = false
                            that.textMsg = ""
                            that.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            },
            // 建立流式回复
            connectToServer(sessionId){
                const that = this
				let url = 'https://appinterface.chongyike.com/ai/videoAssistantHandler?type=getAnswers&sessionId='+ sessionId + that.getConfigText()
				// url = 'http://192.168.18.121:83/ai/videoAssistantHandler?type=getAnswers&sessionId='+ sessionId + that.getConfigText()
				// 建立连接
				let sourceInfo = new EventSource(url);
                // 保存原文参数
                var markedText = ""
                that.textDataBox[that.textDataBox.length-1].replyText = ""
				sourceInfo.onmessage = function(e){
                    var data = JSON.parse(e.data)
                    that.task = data.task
                    markedText += data.content
                    that.markedTextlength = markedText.length
                    that.textDataBox[that.textDataBox.length-1].replyText = marked(markedText).replace(/<del>|<\/del>/g, "");
					// 回复结束
                    if (data.task_state == 1) {
                        var datatext = that.textDataBox[that.textDataBox.length-1].replyText
                        that.textDataBox[that.textDataBox.length-1].replyText = that.escapeUnescapedSquareBrackets(datatext)
                        that.conversationId = data.conversationID
                        that.atPresentConversationID = data.conversationID // 保存当前问答ID
                        that.textDataBox[that.textDataBox.length-1].outputs = data.outputs
                        that.textDataBox[that.textDataBox.length-1].textOver = 2
                        that.textDataBox[that.textDataBox.length-1].session_id = data.sessionId
                        that.textDataBox[that.textDataBox.length-1].relatedreCommended = data.relatedreCommended
                        that.textDataBox[that.textDataBox.length-1].markedText = markedText
                        that.markedTextlength = 0
                        that.getConversationList()
                        that.task = "思考中"
                        that.iscanQuestion()
                    }
				}
				sourceInfo.addEventListener('error', function(e) {
					console.log('内容已断开');
                    that.Answering = false
					sourceInfo.close();
				}, false);
            },
            // 停止流式回复
            stopAnswerts(){
                const that = this
                var data = {
                    type: 'stopAnswerts',
					sessionId: that.sessionId
                }
                this.get("/ai/videoAssistantHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        that.Answering = false
                        if(that.textDataBox[that.textDataBox.length-1].replyText == "思考中......"){
                            that.textDataBox[that.textDataBox.length-1].replyText = ""
                        }
                        that.textDataBox[that.textDataBox.length-1].textOver = 2
                    }
                })
            },
            // 获取历史记录
            getConversationHistory(){
                const that = this
                var data = {
                    type: 'getConversationHistory',
                    dataType: that.videoInfo.dataType,
                    dataNo: that.videoInfo.No,
                }
                this.get("/ai/videoAssistantHandler", data).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        if(result.length > 0){
                            that.textMsg = ""
                            var item = result[0]
                            that.atPresentConversationID = item.conversation_id// 保存当前问答ID
                            result.reverse()
                            that.markedTextlength++ // 保持滚动条在最低端
                            that.startAnswer = true
                            that.conversationId = item.conversation_id
                            for (let i = 0; i < result.length; i++) {
                                if(result[i]){
                                    var answer = result[i]
                                    result[i].markedText = answer.content
                                    result[i].replyText = marked(answer.content).replace(/<del>|<\/del>/g, "");
                                    result[i].replyText = that.escapeUnescapedSquareBrackets(result[i].replyText)
                                    result[i].outputs = answer.outputs
                                    result[i].textOver = 2
                                    result[i].relatedreCommended = answer.relatedreCommended
                                }else {
                                    result[i].replyText = ""
                                    result[i].outputs = ""
                                    result[i].relatedreCommended = []
                                    result[i].textOver = 0
                                }
                                result[i].extendOff = false
                            }
                            that.textDataBox = result  
                        }
                    }
                })
            },
            // 判断是否有提问权限
            iscanQuestion(){
                const that = this
                var data = {
                    type: 'isCanQuestion',
                    dataType: that.videoInfo.dataType,     
                    dataNo: that.videoInfo.No,
                }
                this.get("/ai/videoAssistantHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
                        if(result.is_buy == 1 || result.is_vip == 1 || result.remaining_attempts == 1){
                            that.QuestionPermission = true 
                        }else {
                            that.QuestionPermission = false
                        }
                    }
                })
            },
            // 复制
            copyData(data) {
                const that = this
                const el = document.createElement('textarea');
                // 将需要复制的文本内容赋值给 textarea 元素。
                // el.value = data.markedText;
                el.value = data.replyText.replace(/\<.*?\>/g, '');;
                //将 textarea 元素添加到页面中。
                document.body.appendChild(el);
                //选中 textarea 元素中的文本。
                el.select();
                // 执行复制命令，将选中的文本复制到剪贴板
                document.execCommand('copy');
                //从页面中移除 textarea 元素。
                document.body.removeChild(el);
                //弹出提示框，告知用户文本已复制成功。
                this.$message.success("复制成功")
            },
            // 点赞或踩
            answersLikeOrTap(item,type, index){
                const that = this
                var action = type
                if(item.action == type){
                    action = 0
                }
                var data = {
                    type: 'answersLikeOrTap',
                    action: action,
                    sessionId: item.session_id
                }
                this.get("/ai/videoAssistantHandler", data, 1).then((res) => {
                    if (res.data.code == "success") {
                        var result = res.data.result
						that.$set(that.textDataBox[index], 'action', action)
                    }
                })
            },
            escapeUnescapedSquareBrackets(str) {
                // 首先转义所有已有的反斜杠，以避免影响后续的匹配
                let result = str.replace(/\\/g, '\\\\');

                // 定义一个函数来决定是否需要在 [ 或 ] 前添加 \\
                function shouldEscape(match, offset, string) {
                    // 计算 match 之前有多少个反斜杠
                    let backslashes = (string.slice(0, offset).match(/\\+/g) || ['']).pop() || '';
                    // 如果反斜杠的数量是偶数（包括0），则需要转义
                    return backslashes.length % 2 === 0;
                }
                // 使用正则表达式替换未被转义的 [ 和 ]
                result = result.replace(/([[\]])/g, (match, p1, offset, string) => shouldEscape(match, offset, string) ? '\\\\' +
                    p1 : p1);
                result = result.replace(/([(\)])/g, (match, p1, offset, string) => shouldEscape(match, offset, string) ? '\\\\' +
                    p1 : p1);

                // 恢复原有的单个反斜杠
                result = result.replace(/\\\\/g, '\\');
                return result;
            },
        }
    }
  </script>
  <style lang="scss" scoped>
    textarea {
        padding: 5px !important;
    }
    .title {
        display: flex;
        align-items: center;
        width: 100%;
        height: 88px;
        background-color: #4198e2;
        .text {
            width: 1170px;
            padding-left: 10px;
            font-size: 1.75rem;
            font-weight: normal;
            color: #fff;
            box-sizing: border-box;
            margin: 0 auto;
        }
    }
    .content {
        // overflow: hidden;
        padding: 0;
        .bannerVideoBox {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1000;
            cursor: pointer;
            .video {
                width: 740px;
            }
            .closeBannerBtn {
                font-size: 14px;
                color: #fff;
                background-color: #666;
                position: absolute;
                right: 20px;
                top: 20px;
                height: 30px;
                line-height: 30px;
                border-radius: 15px;
                padding: 0 10px;
                cursor: pointer;
            }

            .bannerPlayBtn {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 100px;
                height: 100px;
                background-color: #fff;
                border-radius: 50%;
            }
        }

        .noVipBox {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1001;
            .coverBgi {
                width: 740px;
                height: 417px;
            }
            .toastBox {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                padding: 30px 50px;
                border-radius: 10px;
                background-color: #fff;
                user-select: none;
                .titles {
                    color: #4198e2;
                    text-shadow: 0px 2px 7px #b1afaf;
                }
                .typeBox {
                    color: #c3911c;
                    padding: 15px 0;
                }
            }
        }
    }
    .videoDetail {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        padding-top: 20px;
        // border-top: 1px solid #ccc;
        .videoDetailTitle {
            padding: 30px 0;
            font-size: 32px;
            color: #444444 ;
        }
        .videoDetailContent {
            // padding: 30px 0 0;
        }
        .videoDetailImg {
            width: 100%;
        }
    }
    
    .bigBox {
        display: flex;
        justify-content: space-between;
        width: 1170px;
        box-shadow: 0 0px 5px #ccc;
        border-radius: 5px;
        margin-bottom: 20px;
        // background-color: #abe2f1;
    }
    .volBox {
        position: relative;
        width: 740px;
        .videoTitle {
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 24px;
            color: #242424;
            height: 75px;
            padding-left: 20px;
            border-radius: 5px;
            .teachers {
                font-size: 16px;
                color: #999;
            }
        }
    }
    .videoList {
        width: 430px;
        height: 490px;
        .tabList {
            display: flex;
            align-items: center;
            padding: 5px 0px;
            box-shadow: 0 2px 5px #ccc;
            .tabItem {
                width: 70px;
                color: #838383;
                font-size: 16px;
                text-align: center;
                cursor: pointer;
                &:hover {
                    color: #206DAF;
                }
            }
            .activeTab {
                position: relative;
                color: #206DAF;
                font-size: 21px;
                &::before {
                    content: "";
                    position: absolute;
                    left: 10px;
                    bottom: -5px;
                    width: 50px;
                    height: 4px;
                    background-color: #206DAF;
                }
            }
        }
        
        .tabContentBox {
            padding: 10px;
            height: 441px;
            box-sizing: border-box;
            overflow-y: auto;
                    
            // 修改滚动条样式
            &::-webkit-scrollbar {
                width: 5px; /* 垂直滚动条的宽度 */
                height: 4px;
            }
            &::-webkit-scrollbar-track {
                background: #fff; /* 滚动条轨道的背景颜色 */
                border-radius: 10px; /* 滚动条轨道的圆角 */
            }
            .videoItemList {
                .videoItem {
                    position: relative;
                    overflow: hidden;
                    padding: 10px 15px;
                    margin-bottom: 10px;
                    border: 1px solid #ebebeb;
                    border-radius: 5px;
                    cursor: pointer;
                        &:hover {
                        .videoTitle {
                            color: #206DAF;
                        }
                    }
                    .videoTitle {
                        color: #393939;
                        font-size: 16px;
                        margin-bottom: 5px;
                    }
                    .videoInfo {
                        position: relative;
                        display: flex;
                        align-items: center;
                        color: #999999;
                        font-size: 14px;
                        .videoIcon {
                            width: 16px;
                            margin-right: 8px;
                        }
                        span {
                            margin-right: 10px;
                        }
                        .teachers {
                            width: 180px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                        }
                        .downloadFileBtn {
                            position: absolute;
                            right: 0;
                            display: flex;
                            align-items: center;
                            font-size: 14px;
                            color: #206DAF;
                            cursor: pointer;
                            &:hover {
                                color: #363636;
                            }
                            .downloadFileIcon {
                                width: 14px;
                                margin-right: 5px;
                            }
                        }
                    }
                    .labelIcon {
                        position: absolute;
                        right: 0;
                        top: 0;
                        width: 32px;
                        height: 14px;
                    }
                }
                .activeVideoItem {
                    border: 1px solid #206daf;
                    background-color: #eef7ff;
                }
            }

            .AItitle {
                position: relative;
                font-size: 16px;
                color: #242424;
                .videoAbstractOpenBtn {
                    position: absolute;
                    width: auto;
                    right: 20px;
                    top: 2px;
                }
            }
            .videoAbstract {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                font-size: 14px;
                color: #6D6D6D;
                padding: 10px 0;
                height: 70px;
                box-sizing: border-box;
            }
            .openVideoAbstract {
                font-size: 14px;
                color: #6D6D6D;
                padding: 10px 0;
                box-sizing: border-box;
            }
            .videoAbstractOpenBtn {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 14px;
                color: #206DAF;
                user-select: none;
                margin-bottom: 15px;
                cursor: pointer;
                .btmIcon {
                    width: 20px;
                    margin-right: 5px;
                    
                }
            }
            
            .SummaryBySectionsBox {
                padding: 10px;
                background-color: #fff;
                border: 2px solid #e7eaff;
                border-radius: 10px;
                margin-bottom: 15px;
                .SummaryBySectionsList {
                    padding: 10px 0;
                    max-height: 300px;
                    overflow: hidden;
                    margin-bottom: 10px;
                }
                .SummaryBySectionsList2 {
                    padding: 10px 0;
                }
                .SummaryBySectionsItem {
                    .SummaryBySectionsItemTitle {
                        position: relative;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        color: #242424;
                        font-size: 14px;
                        padding-left: 30px;
                        padding-right: 60px;
                        width: 390px;
                        box-sizing: border-box;
                        .videoIcon {
                            position: absolute;
                            width: 16px;
                            left: 5px;
                            cursor: pointer;
                        }
                        .videoTimes {
                            position: absolute;
                            right: 10px;
                            font-size: 14px;
                            color: #6D6D6D;
                        }
                    }
                    .SummaryBySectionsContent {
                        padding: 8px 0;
                        padding-left: 30px;
                        color: #6D6D6D;
                        font-size: 14px;
                    }
                }
            }

            .qaListBox{
                padding: 10px 0;
                .qaItem {
                    position: relative;
                    color: #242424;
                    font-size: 14px;
                    padding-left: 30px;
                    margin-bottom: 10px;
                    .videoIcon {
                        position: absolute;
                        width: 20px;
                        left: 5px;
                        cursor: pointer;
                    }
                    .qBox {
                        margin-bottom: 6px;
                    }
                    .aBox {
                        margin-bottom: 20px;
                    }
                }
            }
        
            .btnList {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 10px;
                .allNoteBtn {
                    color: #206DAF;
                    font-size: 16px;
                    cursor: pointer;
                }
                .rightBtn {
                    display: flex;
                    align-items: center;
                    .btnItem {
                        color: #206DAF;
                        background-color: #fff;
                        font-size: 16px;
                        padding: 2px  8px;
                        border-radius: 5px;
                        margin-left: 10px;
                        border: 1px solid #206DAF;
                        cursor: pointer;
                        .videoIcon {
                            width: 14px;
                        }
                    }
                    .saveBtn {
                        color: #fff;
                        background-color: #206DAF;
                    }
                }

            }
            
            .noteTitleInputBox {
                margin-bottom: 5px;
                .noteTitleInput {
                    width: 330px;
                    height: 40px;
                    font-size: 20px;
                    border: none;
                    padding: 0 5px;
                    outline: none;
                }
            }
            .noteContentTextarea {
                width: 100%;
                font-size: 16px;
            }
            .upimgList {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding-top: 15px;
                .upImgItem {
                    width: 132px;
                    height: 73px;
                    box-sizing: border-box;
                    border: 1px solid #dadada;
                    margin-right: 6px;
                    margin-bottom: 10px;
                    .upImgItemSrc {
                        width: 100%;
                        height: 70px;
                    }
                    &:nth-child(3n){
                        margin-right: 0;
                    }
                }
                .upImgBtn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    color: #242424;
                    border: 1px dashed #dadada;
                    user-select: none;
                    cursor: pointer;
                }
            }

            .PPTDataListBox {
                .PPTDataListItem {
                    padding: 5px 5px;
                    .iconBox {
                        display: flex;
                        align-items: center;
                        .videoIcon {
                            width: 20px;
                            height: 20px;
                            margin-right: 8px;
                            cursor: pointer;
                        }
                        .videoTimes {
                            padding-top: 3px;
                            font-size: 16px;
                            line-height: 20px;
                            color: #6D6D6D;
                        }
                    }
                    .pptContent {
                        padding: 8px 0;
                        color: #6D6D6D;
                        font-size: 14px;
                    }
                }
            }
        }
        .askContentBox {
            position: relative;
            .learningTarget {
                margin-bottom: 20px;
                .learningTargetTitle {
                    padding: 2px 10px;
                    font-size: 12px;
                    color: #fff;
                    background-color: #9acbf5;
                }
                .learningTargetList {
                    padding: 5px 10px;
                    font-size: 12px;
                    color: #333;
                    background-color: #f4f4ff;
                    white-space: pre-wrap;
                    /* 保留空白符序列，但是正常地进行换行 */
                    overflow-wrap: break-word;
                }
            }
            .askInputBox {
                position: absolute;
                bottom: 0;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px;
                width: 100%;
                box-sizing: border-box;
                background-color: #f8f8f8;
                z-index: 2;
                .askInput {
                    width: 300px;
                    height: 40px;
                    font-size: 16px;
                    border: none;
                    padding: 0 10px;
                    outline: none;
                }
                .sendBtn {
                    width: 52px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    color: #fff;
                    background-color: #206daf;
                    border-radius: 5px;
                    user-select: none;
                    cursor: pointer;
                }
            }
            .askItemList {
                padding: 0 5px 100px;
                height: 421px;
                box-sizing: border-box;
                overflow-y: auto;
                .askItem {
                    padding: 15px 0;
                    display: flex;
                    border-bottom: 1px solid #f0f0f0;
                    .userHeadPortrait {
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        margin-right: 12px;
                    }
                    .contentBox {
                        font-size: 16px;
                        color: #545454;
                    }
                    .userName {
                        position: relative;
                        display: flex;
                        align-items: center;
                        color: #206DAF;
                        width: 330px;
                        padding-right: 50px;
                        box-sizing: border-box;
                        .deleteBtn {
                            position: absolute;
                            right: 10px;
                            font-size: 14px;
                            color: #999;
                            user-select: none;
                            cursor: pointer;
                        }
                    }
                    .userContent {
                        padding: 8px 0;
                    }
                    .contentInfo {
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        color: #999;
                        span {
                            margin-left: 5px;
                            font-size: 15px;
                            color: #363636;
                            cursor: pointer;
                        }
                    }
                    .userAskList {
                        .userAskItem {
                            padding-top: 10px;
                            font-size: 14px;
                            color: #393939;
                            .doctorName {
                                color: #206DAF;
                            }
                        }
                    }
                }
            }
        }
    }
    .noteList {
        overflow-y: scroll;
        height: 40vh;
        .noteItem {
            padding: 10px;
            margin-bottom: 15px;
            border: 2px solid #d2e2ef;
            .noteEditTitle {
                font-size: 16px;
                color: #242424;
            }
            .noteTime {
                display: flex;
                align-items: center;
                padding: 5px 0;
            }
            .noteEditContent {
                display: flex;
                font-size: 16px;
                color: #6D6D6D;
                min-height: 50px;
                .noteImgItemSrc {
                    width: 270px;
                    height: 150px;
                    border: 1px solid #d2e2ef;
                    margin-right: 10px;
                }
            }
            .operatingButtonList {
                display: flex;
                flex-direction: row-reverse;
                .operatingBtnItem {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    padding: 0 10px;
                    color: #206DAF;
                    border-right: 1px solid #d2e2ef;
                    cursor: pointer;
                    &:nth-child(1){
                        border: none;
                    }
                }
                .deleteBtn {
                    color: #FF6F6F;
                }
            }
            .noteIcon {
                width: 16px;
                margin-right: 5px;
            }
        }
    }

    // 修改滚动条样式
    ::-webkit-scrollbar {
        width: 5px; /* 垂直滚动条的宽度 */
        height: 4px;
    }
    .el-dialog__body {
        padding: 10px 20px;
    }
    .transitionBox {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 120px;
        height: 120px;
        z-index: 10000;
        transform: translate(-50%, -50%);
        background-color: rgba(0,0,0,0.5);
        border-radius: 5px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        .voiceIcon {
            width: 50px;
            margin-right: 10px;
        }
    }


    
    .textBox {
        overflow-x: hidden;
        overflow-y: scroll;
        width: 100%;
        height: 100%;
        padding: 20px 0 0;
        box-sizing: border-box;
        line-height: 25px;
        .answerItem {
            margin: 0 auto;
        }
        .rightText {
            float: right;
            padding: 10px;
            border-radius: 10px;
            margin-bottom: 10px;
            margin-left: 30px;
            margin-right: 10px;
            font-size: 13px;
            background-color: #eef8ff;
            .imgItem {
                display: flex;
                align-items: center;
                width: 210px;
                padding: 10px;
                border-radius: 5px;
                margin-bottom: 10px;
                border: 1px solid #cacaca;
                background-color: #f9f9f9;
                .imgInfo {
                    padding-left: 10px;
                    color: #333;
                    user-select: none;
                    .imgName {
                        width: 100px;
                        overflow: hidden;
                        text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
                        font-size: 18px;
                    }
                    .imgsize {
                        color: #b0b0b0;
                        font-size: 14px;
                        span {
                            padding-right: 10px;
                        }
                    }
                }
            }
        }
        .leftBox {
            float: left;
            .leftImg {
                display: flex;
                align-items: center;
                color: #333;
                font-size: 18px;
                position: relative;
                margin-bottom: 10px;
                .logo {
                    width: 30px;
                    height: 30px;
                    padding: 5px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
            }
            .leftText {
                box-sizing: border-box;
                border-radius: 10px;
                margin-right: 30px;
                font-size: 15px;
                .outputsBox {
                    padding: 10px 20px;
                    margin-top: 10px;
                    color: #4b96ef;
                    border-left: 2px solid #c5e9ff;
                    .outputsItem {
                        width: 30vw;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        height: 30px;
                        line-height: 30px;
                        font-size: 13px;
                        cursor: pointer;
                        .dataName {
                            font-size: 12px;
                            padding: 2px 4px;
                            margin-right: 5px;
                            border-radius: 5px;
                            background-color: #ffefce;
                        }
                        .color1 {
                            color: #ff7b00;
                        }
                        .color2 {
                            color: #30c400;
                        }
                    }
                    .btn {
                        width: 100%;
                        text-align: center;
                        user-select: none;
                        cursor: pointer;
                        .extendBtn {
                            width: 18px;
                            padding: 0 5px;
                        }
                    }
                }

                .btnList {
                    display: flex;
                    align-items: center;
                    padding: 10px 0;
                    width: 200px;
                    .btnItem {
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        padding: 0px 10px;
                        color: #4488cc;
                        border-radius: 100px;
                        margin-right: 10px;
                        border: 1px solid #4488cc;
                        cursor: pointer;
                        .icon {
                            width: 15px;
                        }
                        .bottom {
                            transform: rotate(180deg);
                        }
                    }
                }
            }
        }
    }

  </style>
   